import type React from "react";

const HeroArt: React.FC = () => {
  return (
    <svg
      viewBox="0 0 460 380"
      xmlns="http://www.w3.org/2000/svg"
      role="img"
      aria-label="Searching a knowledge base and surfacing ranked, sourced results"
      className="hero-art"
    >
      <defs>
        <linearGradient id="paper" x1="0" y1="0" x2="0" y2="1">
          <stop offset="0" stopColor="#fdeedd" />
          <stop offset="1" stopColor="#f6d8b8" />
        </linearGradient>
        <linearGradient id="cubeTop" x1="0" y1="0" x2="1" y2="1">
          <stop offset="0" stopColor="#ffb274" />
          <stop offset="1" stopColor="#ff9152" />
        </linearGradient>
        <linearGradient id="cubeLeft" x1="0" y1="0" x2="0" y2="1">
          <stop offset="0" stopColor="#f06f36" />
          <stop offset="1" stopColor="#e25a23" />
        </linearGradient>
        <linearGradient id="cubeRight" x1="0" y1="0" x2="0" y2="1">
          <stop offset="0" stopColor="#dd5b22" />
          <stop offset="1" stopColor="#cb4a17" />
        </linearGradient>
        <linearGradient id="card" x1="0" y1="0" x2="0" y2="1">
          <stop offset="0" stopColor="#ffffff" />
          <stop offset="1" stopColor="#f3f5f9" />
        </linearGradient>
      </defs>

      <ellipse cx="150" cy="320" rx="120" ry="20" fill="#000" opacity="0.05" />
      <ellipse cx="370" cy="300" rx="78" ry="14" fill="#000" opacity="0.05" />

      <g>
        <rect
          x="58"
          y="92"
          width="132"
          height="168"
          rx="10"
          fill="#ecc8a0"
          transform="rotate(-9 124 176)"
        />
        <rect
          x="46"
          y="84"
          width="132"
          height="168"
          rx="10"
          fill="#f3d4ad"
          transform="rotate(-4 112 168)"
        />
        <rect
          x="36"
          y="78"
          width="132"
          height="170"
          rx="10"
          fill="url(#paper)"
          stroke="#e9c79e"
          strokeWidth="1.5"
        />
        <rect x="50" y="92" width="40" height="40" rx="5" fill="#3f4a44" />
        <circle cx="62" cy="104" r="5" fill="#ff9a5c" />
        <path d="M52 122 L62 110 L72 122 Z" fill="#2c3530" />
        <g fill="#2b2f37">
          <rect
            x="100"
            y="92"
            width="40"
            height="40"
            rx="4"
            fill="#fff"
            stroke="#e9c79e"
          />
          <rect x="104" y="96" width="8" height="8" />
          <rect x="128" y="96" width="8" height="8" />
          <rect x="104" y="120" width="8" height="8" />
          <rect x="116" y="108" width="6" height="6" />
          <rect x="126" y="118" width="9" height="9" />
        </g>
        <rect x="50" y="146" width="100" height="6" rx="3" fill="#caa276" />
        <rect x="50" y="160" width="100" height="6" rx="3" fill="#d9b98e" />
        <rect x="50" y="174" width="78" height="6" rx="3" fill="#d9b98e" />
        <rect x="50" y="188" width="100" height="6" rx="3" fill="#d9b98e" />
        <rect x="50" y="202" width="64" height="6" rx="3" fill="#e3c8a3" />
      </g>

      <g>
        <circle cx="148" cy="216" r="52" fill="#ffffff" opacity="0.92" />
        <circle
          cx="148"
          cy="216"
          r="52"
          fill="none"
          stroke="#e8821e"
          strokeWidth="7"
        />
        <circle
          cx="148"
          cy="216"
          r="44"
          fill="none"
          stroke="#f6c79a"
          strokeWidth="2"
        />
        <rect
          x="124"
          y="206"
          width="48"
          height="6"
          rx="3"
          fill="#e8821e"
          opacity="0.55"
        />
        <rect
          x="124"
          y="220"
          width="34"
          height="6"
          rx="3"
          fill="#e8821e"
          opacity="0.35"
        />
        <rect
          x="187"
          y="252"
          width="22"
          height="46"
          rx="11"
          fill="#e8821e"
          transform="rotate(-45 198 275)"
        />
      </g>

      <path
        d="M212 196 C 250 176, 268 176, 296 184"
        fill="none"
        stroke="#e8821e"
        strokeWidth="2.4"
        strokeDasharray="5 5"
        strokeLinecap="round"
      />

      <g>
        <polygon points="345,118 393,146 345,174 297,146" fill="url(#cubeTop)" />
        <polygon
          points="297,146 345,174 345,232 297,204"
          fill="url(#cubeLeft)"
        />
        <polygon
          points="393,146 345,174 345,232 393,204"
          fill="url(#cubeRight)"
        />
        <polygon
          points="345,118 393,146 345,174 297,146"
          fill="none"
          stroke="#ffd0a8"
          strokeWidth="1"
          opacity="0.6"
        />
        <text
          x="321"
          y="200"
          fontFamily="Arial, sans-serif"
          fontSize="20"
          fontWeight="800"
          fill="#fff"
          textAnchor="middle"
        >
          AI
        </text>
      </g>

      <path
        d="M393 168 C 416 158, 426 150, 432 134"
        fill="none"
        stroke="#e8821e"
        strokeWidth="2.4"
        strokeDasharray="5 5"
        strokeLinecap="round"
      />
      <path
        d="M393 196 C 418 200, 426 206, 432 214"
        fill="none"
        stroke="#c9c4b6"
        strokeWidth="2.2"
        strokeDasharray="5 5"
        strokeLinecap="round"
      />

      <g>
        <rect
          x="356"
          y="106"
          width="92"
          height="56"
          rx="9"
          fill="url(#card)"
          stroke="#e6e2d8"
          strokeWidth="1.5"
        />
        <rect x="356" y="106" width="5" height="56" rx="2.5" fill="#e8821e" />
        <rect x="370" y="118" width="50" height="6" rx="3" fill="#3f4a44" />
        <rect x="370" y="131" width="64" height="5" rx="2.5" fill="#cfd3da" />
        <rect x="370" y="142" width="40" height="5" rx="2.5" fill="#dfe2e8" />
        <rect x="412" y="148" width="28" height="9" rx="4.5" fill="#e7f3ea" />
        <circle cx="418" cy="152.5" r="2.4" fill="#2f9e6b" />
        <rect x="423" y="150" width="13" height="5" rx="2.5" fill="#54b487" />
        <rect
          x="356"
          y="174"
          width="92"
          height="44"
          rx="9"
          fill="url(#card)"
          stroke="#e6e2d8"
          strokeWidth="1.5"
        />
        <rect x="368" y="186" width="46" height="6" rx="3" fill="#6b7180" />
        <rect x="368" y="198" width="62" height="5" rx="2.5" fill="#dfe2e8" />
        <rect
          x="356"
          y="230"
          width="92"
          height="40"
          rx="9"
          fill="url(#card)"
          stroke="#e6e2d8"
          strokeWidth="1.5"
          opacity="0.92"
        />
        <rect x="368" y="241" width="42" height="6" rx="3" fill="#8a90a0" />
        <rect x="368" y="252" width="58" height="5" rx="2.5" fill="#e7eaef" />
      </g>

      <g transform="translate(150 286)">
        <ellipse cx="0" cy="0" rx="30" ry="9" fill="#6c7e85" />
        <path d="M-30 0 V20 A30 9 0 0 0 30 20 V0" fill="#5d7079" />
        <ellipse cx="0" cy="0" rx="30" ry="9" fill="#7d909a" />
        <ellipse cx="0" cy="0" rx="22" ry="6" fill="#46565d" opacity="0.55" />
      </g>
      <g transform="translate(232 268)">
        <path
          d="M0 -22 L20 -14 V4 C20 18 10 26 0 30 C-10 26 -20 18 -20 4 V-14 Z"
          fill="#cdd6d3"
          stroke="#aeb9b5"
          strokeWidth="1.5"
        />
        <path
          d="M-8 2 L-2 9 L10 -6"
          fill="none"
          stroke="#2f9e6b"
          strokeWidth="3.4"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
    </svg>
  );
};

export default HeroArt;
